export default {
  shadows: {
    default: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    preview: ' 0px 10px 60px rgba(34, 42, 57, 0.3);',
    character: '0px 2px 10px rgba(0, 0, 0, 0.1)',
  },
}
